import { useQuery } from '@tanstack/react-query';
import { getAxios } from '../../../../lib/axios';
import { CompanyRelatedCompanyModel } from '../types/CompanyRelatedCompanyModel';
import { CrmEndpoints } from '../../../../constants/endpoints/crmEndpoints';

export function useCompanyRelatedCompanyQuery(companyId: number | undefined, isDialogOpen: boolean = true) {
  return useQuery({
    queryKey: ['CompanyRelatedCompany', companyId],
    queryFn: async () =>
      (await getAxios().get<CompanyRelatedCompanyModel>(`${CrmEndpoints.CompanyCrm.RelatedCompany.get(companyId)}`))
        .data,
    enabled: companyId !== undefined && companyId !== null && companyId > 0 && isDialogOpen
  });
}
